var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBridge({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "lucide lucide-pocket-knife-icon lucide-pocket-knife",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 2v1c0 1 2 1 2 2S3 6 3 7s2 1 2 2-2 1-2 2 2 1 2 2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18 6h.01"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6 18h.01"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.83 8.83a4 4 0 0 0-5.66-5.66l-12 12a4 4 0 1 0 5.66 5.66Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18 11.66V22a4 4 0 0 0 4-4V6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBridge);
export default __webpack_public_path__ + "static/media/bridge.f247b0f8e5919ec75bb3ae08281a6c7f.svg";
export { ForwardRef as ReactComponent };